import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationContants } from '../constants/authentication-constants';
import { ModuleModel } from '../models/authentication/module.model';
import { WindowModel } from '../models/authentication/window.model';

@Injectable({
  providedIn: 'root',
})
export class CanActivateViewGuard {
  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const menu = localStorage.getItem(
      AuthenticationContants.keyMenuUserLocalStorage
    );
    const tokenUser = localStorage.getItem(
      AuthenticationContants.keyTokenLocalStorage
    );

    const menuObject = JSON.parse(menu || '[]');
    if (menu && tokenUser) {
      const response = menuObject.find((x: ModuleModel) => x.windows.find((y: WindowModel) => y.urlWindow === state.url.split('/')[1]));
      if (response) return response;
      else this.router.navigate(['/main']);
    }

    if (!menu || !tokenUser) {
      this.router.navigate(['/login']);
    }

    return false;
  }
}
